import { Text, View } from "@react-pdf/renderer";
import React from "react";

const DocumentDetailComment = ({ comment }: { comment: string }) => {
  return (
    <View
      style={{
        paddingLeft: "15mm",
      }}
    >
      <Text
        style={{
          fontFamily: "Pretendard",
          fontSize: "10pt",
          fontWeight: 400,
          alignItems: "flex-start",
          color: "#65434C",
        }}
      >
        {comment}
      </Text>
    </View>
  );
};

export default DocumentDetailComment;
